// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__28X2Q","options":"AnswerScale_options__1Q93L","selected":"AnswerScale_selected__3G7ha"};